// 工程訂單列表
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, money, fmtDate, ORDER_STATUS, r2 } from '../api.js';
import { StatusBadge, CategoryTag, Loading, Empty, PageHead, useToast, useConfirm } from '../ui.jsx';

export default function Orders() {
  const nav = useNavigate();
  const { toast } = useToast();
  const [confirm, confirmNode] = useConfirm();
  const [rows, setRows] = useState(null);
  const [status, setStatus] = useState('');
  const [q, setQ] = useState('');
  useEffect(() => {
    const p = new URLSearchParams();
    if (status) p.set('status', status);
    if (q) p.set('q', q);
    api.get(`/orders?${p}`).then(setRows);
  }, [status, q]);
  const del = (row) => confirm(`刪除訂單 ${row.order_no}？(已開發票或採購單不可刪)`, async () => {
    try { await api.del(`/orders/${row.id}`); toast('已刪除'); setRows(l => l.filter(x => x.id !== row.id)); }
    catch (e) { toast(e.message, 'err'); }
  }, { danger: true, okLabel: '刪除' });

  return (
    <div>
      <PageHead icon="🏗️" title="工程訂單 Orders" desc="報價轉單 · 自動開票 · 掛單採購 — 每張訂單自動計算利潤"
        actions={<div className="search-box"><input className="input" placeholder="搜尋訂單/客戶…" value={q} onChange={e => setQ(e.target.value)} /></div>} />
      <div className="row mb">
        <div className="pill-filter">
          <button className={`pill ${!status ? 'active' : ''}`} onClick={() => setStatus('')}>全部</button>
          {Object.entries(ORDER_STATUS).map(([k, v]) => (
            <button key={k} className={`pill ${status === k ? 'active' : ''}`} onClick={() => setStatus(k)}>{v.label}</button>
          ))}
        </div>
      </div>
      <div className="card">
        {rows === null ? <Loading /> : rows.length === 0 ? <Empty icon="🏗️" text="沒有訂單 — 由報價單「轉訂單」開始" /> : (
          <div className="tbl-wrap">
            <table className="tbl">
              <thead>
                <tr><th>訂單</th><th>工程</th><th>客戶</th><th>日期</th><th className="num">合約額</th><th className="num">已開票</th><th className="num">採購成本</th><th className="num">利潤</th><th>狀態</th><th></th></tr>
              </thead>
              <tbody>
                {rows.map(o => {
                  const profit = r2(o.invoiced - o.po_total);
                  return (
                    <tr key={o.id} className="clickable" onClick={() => nav(`/orders/${o.id}`)}>
                      <td className="strong">{o.order_no}<div className="sub" style={{ marginTop: 2 }}>{o.quote_no ? `← ${o.quote_no}` : ''}</div></td>
                      <td style={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        <div>{o.title || '—'}</div><div style={{ marginTop: 3 }}><CategoryTag value={o.category} /></div>
                      </td>
                      <td>{o.customer_name}</td>
                      <td>{fmtDate(o.order_date)}</td>
                      <td className="num">{money(o.total)}</td>
                      <td className="num">{money(o.invoiced)}</td>
                      <td className="num">{money(o.po_total)}</td>
                      <td className="num strong" style={{ color: profit >= 0 ? 'var(--mint)' : 'var(--coral)' }}>{money(profit)}</td>
                      <td><StatusBadge map={ORDER_STATUS} value={o.status} /></td>
                      <td onClick={e => e.stopPropagation()}>
                        {api.user?.role === 'admin' && ['open', 'in_progress'].includes(o.status) ? <button className="btn sm coral" onClick={() => del(o)}>🗑️</button> : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {confirmNode}
    </div>
  );
}
